<template>
    <BlogForm :token="token" :blogId="blog?.id" />
</template>

<script>
import BlogForm from './BlogForm.vue'

export default {
    name: 'BlogCreate',
    components: {
        BlogForm,
    },
    props: {
        token: {
            type: String,
            required: true,
        },
        blog: {
            type: Object,
            default: null,
        },
    },
}
</script>
